import { Link } from '@mui/material';
import React, { FC } from 'react';

import Input from '../../components/Input/Input';
import { InputFields, RawField } from '../../forms';
import Logo from '../Logo';

type TLogin = {
  dataset: {
    resetLink: string;
  };
};

const Login: FC<TLogin> = ({ dataset }) => {
  const FormFields = {
    email: { ...InputFields.email, required: true },
    password: { ...InputFields.password, required: true },
  } as const satisfies Record<string, RawField>;

  return (
    <form className='auth-form' method='POST'>
      <Logo />

      <Input
        label={FormFields.email.label}
        inputProps={{
          tabIndex: FormFields.email.tabIndex,
          required: FormFields.email.required,
          maxLength: FormFields.email.maxLength,
          pattern: FormFields.email.pattern,
        }}
        type={FormFields.email.type}
        name={FormFields.email.name}
        size='small'
        fullWidth
        sx={{ width: '300px' }}
      />

      <Input
        label={FormFields.password.label}
        inputProps={{
          tabIndex: FormFields.password.tabIndex,
          required: FormFields.password.required,
          maxLength: FormFields.password.maxLength,
          pattern: FormFields.password.pattern,
        }}
        type={FormFields.password.type}
        name={FormFields.password.name}
        size='small'
        fullWidth
        sx={{ width: '300px' }}
      />

      <Link href={dataset.resetLink} underline='hover'>
        パスワードをお忘れの時はこちら
      </Link>

      <button className='btn btn--main btn--fix' type='submit'>
        ログイン
      </button>
    </form>
  );
};

export default Login;
